<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Checker Rejected Form</h4>
      </div>

      <!-- Employee Table -->
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Employee ID</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Department</th>
            <th>Requester</th>
            <th>Checker</th>
            <th>Approver</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.CheckerITfacilityRejectiongrid; let i = index">
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td>
              <button 
  class="btn btn-secondary btn-sm" 
  type="button" 
  (click)="verifyemployee(emp.IR_EmployeeId)">
  Verify
</button>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.IR_EmployeeId }}</td>
            <td>{{ emp.IR_Fullname }}</td>
            <td>{{ emp.IR_Designation }}</td>
            <td>{{ emp.IR_Grade }}</td>
            <td>{{ emp.IR_Department }}</td>
            <td>{{ emp.IR_Createdby }}</td>
            <td>{{ emp.IR_ReporterName }}</td>
            <td>{{ emp.IR_Createdby }}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
